declare const window: Window & { dataLayer: Record<string, unknown>[] };

enum AnalyticsPlatform {
  GTM = 'GTM',
}

export const trackAnalyticsEvent = (
  eventName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- customParams can contain array of any type
  customParams?: Record<string, string | any[]>,
  platform: AnalyticsPlatform = AnalyticsPlatform.GTM
) => {
  if (platform === AnalyticsPlatform.GTM) {
    window.dataLayer.push({ event: eventName, ...customParams });
  }
};
